import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Modal } from 'components/antd';
import { PastBookingsStore, RootStore } from 'AppClient/stores';
import LeaveBookingFeedbackForm from './LeaveBookingFeedbackForm';
import { LeaveBookingFeedbackRequest } from 'AppClient/api/Bookings';
import { Spin } from 'components/antd';

interface Props extends FormComponentProps {
	pastBookingsStore?: PastBookingsStore;
}

const TripFeedbackComponent: React.FC<Props> = props => {
	const [rating, setRating] = React.useState(0);
	const { isShownBookingFeedbackModal: visible, toggleModal, bookingFeedbackModalData: data, isPending } = props.pastBookingsStore!;
	const { form } = props;
	const toApiData = (): LeaveBookingFeedbackRequest => ({
		rating,
		bookingId: data.bookingId
	});

	React.useEffect(() => {
		if (visible) {
			setRating(0);
		}
	}, [visible])
	
	const changeRatingHandler = (rating: number): any => {
		setRating(rating)
	}

	return (
		<div>
			{visible ? (
				<Modal
					visible={visible}
					onCancel={toggleModal}
					title='How was your trip?'
					onOk={() => {
						props.pastBookingsStore!.leaveBookingFeedback(toApiData());
					}}
					okButtonProps={{
						disabled: !rating,
					}}
					okText={'Send Feedback'}
					destroyOnClose
				>
					<Spin spinning={isPending}>
						<LeaveBookingFeedbackForm form={form} onChangeRating={changeRatingHandler} data={data} />
					</Spin>
				</Modal>
			) : null}
		</div>
	);
};
const WrapperComponent = inject(({ pastBookingsStore }: RootStore) => ({
	pastBookingsStore
}))(observer(TripFeedbackComponent));
export const BookingFeedbackModal = Form.create({ name: 'LeaveBookingFeedbackForm' })(WrapperComponent);
